class LookupHandler {
  constructor() {
    this.lookupColumnDefinitions = [];
    this.lookupdata = [];
    this.lookupDataCallback = null;
    this.lookupCriteria = null;
    this.lookupCriteriaView = null;
    this.lookupTitle = "";
  }
  setDetails = (lookupDataCallback, lookupCriteria, lookupCriteriaView) => {
    this.lookupDataCallback = lookupDataCallback;
    this.lookupCriteria = lookupCriteria;
    this.lookupCriteriaView = lookupCriteriaView;
  };
  addColumnDefinition = (
    columnDisplayName,
    columnBindingPropertyName,
    columnAlignment,
    valueColumn
  ) => {
    let columnDef = new LookupDataColumnDefinition();
    columnDef.setDetails(
      columnDisplayName,
      columnBindingPropertyName,
      columnAlignment,
      valueColumn
    );
    this.lookupColumnDefinitions.push(columnDef);
  };
  handleCriteria(lookup_dialog) {
    // Open Criteria
    //TODO
    //let criteria_dialog = new LookupCriteriaDialog(this.lookupTitle,this.lookupCriteriaView,this.lookupCriteria);
    //criteria_dialog.init_criteria(lookup_dialog);
    //this.initCriteriaView(criteria_dialog) ;
  }
  initCriteriaView(criteria_dialog) {
    // To be Override
  }
}
export class LookupDataColumnDefinition {
  constructor() {
    this.columnDisplayName = "";
    this.columnBindingPropertyName = "";
    this.columnAlignment = 0; // 0 -->Left  1-->Right  2-->Center
    this.valueColumn = false;
  }
  setDetails = (
    columnDisplayName,
    columnBindingPropertyName,
    columnAlignment,
    valueColumn
  ) => {
    this.columnDisplayName = columnDisplayName;
    this.columnBindingPropertyName = columnBindingPropertyName;
    this.columnAlignment = columnAlignment;
    this.valueColumn = valueColumn;
  };
}
export class LookupValueSelectedEventHandler {
  valueSelected(selectedValue) {
    //Do Nothing
  }
}
export class LookupResultDetails {
  constructor() {
    this.pageData = null;
    this.pageSize = 0;
    this.totalRecordsCount = 0;
    this.currentPageNumber = 0;
    this.criteriaDisplayString = "";
  }
  setDetails = (
    pageData,
    pageSize,
    totalRecordsCount,
    currentPageNumber,
    criteriaDisplayString
  ) => {
    this.pageData = pageData;
    this.pageSize = pageSize;
    this.totalRecordsCount = totalRecordsCount;
    this.currentPageNumber = currentPageNumber;
    this.criteriaDisplayString = criteriaDisplayString;
  };
}
export { LookupHandler };
